import { render, staticRenderFns } from "./SiteNavDesktopShopMenu.vue?vue&type=template&id=54369cec&scoped=true&lang=pug&"
import script from "./SiteNavDesktopShopMenu.vue?vue&type=script&lang=js&"
export * from "./SiteNavDesktopShopMenu.vue?vue&type=script&lang=js&"
import style0 from "./SiteNavDesktopShopMenu.vue?vue&type=style&index=0&id=54369cec&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54369cec",
  null
  
)

export default component.exports